import { object } from 'common/helpers'


export const initialState = {}

let zIndex = 0

export const open = (state, { name, data = {}, options: { zIndex: passedZIndex } = {} }) => {
  ++zIndex
  return { ...state, [name]: { name, data, zIndex: passedZIndex || zIndex } }
}

export const close = (state, payload /* name */) => {
  const _state = { ...state }
  delete _state[payload]

  if (Object.keys(_state).length === 0) {
    zIndex = 0
  }

  return _state
}

export const update = (state, { name, data = {} }) => (
  object.updateIn(state, [name, 'data'], (v) => object.mergeDeep(v, data))
)

export const closeAll = () => ({})
